'use strict';
const angular = require('angular');

export default angular.module('wftOrderFormApp.file-input', [])
  .directive('fileInput', function() {
    return {
      restrict: 'A',
      scope: {
        fileInput: '='
      },
      link: function(scope, element, attrs) {
        element.bind('change', function (event) {
          var file = event.target.files[0];
          scope.fileInput = file ? file : undefined;
          scope.$apply();
        });
      }
    };
  })
  .name;



// WEBPACK FOOTER //
// ./client/app/directives/file-input/file-input.directive.js